import axios from 'axios';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ANALYTICS_API_URL } from '../../../../constants/config';
import { Spinner } from '../../../common';
import * as browserStorage from '../../../../misc/BrowserStorageManager';

export const ScreenCenter = styled.div`
   position: absolute;
   top: 50%;
   left: 50%;
   margin-right: -50%;
   transform: translate(-50%, -50%);
`;
ScreenCenter.displayName = 'ScreenCenter';

export const Text = styled.h1`
   color: rgb(180, 180, 180);
`;
Text.displayName = 'Text';

function TokenLogin({ location, history }) {
   useEffect(() => {
      async function fetchAuthData() {
         try {
            const urlParams = new URLSearchParams(location.search);
            const singleUseToken = urlParams.get('token');
            const options = {
               method: 'GET',
               url: `${ANALYTICS_API_URL}/authenticate`,
               params: { singleUseToken },
            };

            const res = await axios.request(options);
            const data = res.data;
            const url = data.link;
            delete data.link;

            let userInfo = JSON.stringify(data);
            browserStorage.setItem('userInfo', userInfo);
            window.location.href = url;
         } catch (error) {
            history.push('/login');
         }
      }
      fetchAuthData();
   }, [location, history]);

   //  const handleClick = () => {
   //      history.push("/path/to/push");
   //  }

   return (
      <ScreenCenter>
         <Text>{'Redirecting'}</Text>
         <Spinner loading={true} childColor={'rgb(180, 180, 180)'}></Spinner>
      </ScreenCenter>
   );
}

export default TokenLogin;
